import { render } from "./flexVolume.vue?vue&type=template&id=01b319b8"
import script from "./flexVolume.vue?vue&type=script&lang=js"
export * from "./flexVolume.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__